/* eslint-disable no-debugger */
import { AxiosResponse } from "axios";

import { IPaginatedResponse } from "../@types/PaginatedResponse";
import { IMedicationAdherenceResponse } from "../@types/Patient";
import { api } from "./api";

export const medicationService = {
  async getMedications(patientId: number): Promise<AxiosResponse> {
    const url = "/Portal/Medications";

    const urlParamsParsed = new URLSearchParams();

    urlParamsParsed.append("patientId", patientId.toString());

    const medicationsResponse = await api.get<IPaginatedResponse<any>>(url, {
      params: urlParamsParsed,
    });

    return medicationsResponse;
  },

  async getMedicationsPaginated(
    patientId: number,
    page?: number,
    pageSize?: number
  ): Promise<AxiosResponse<IPaginatedResponse<any>>> {
    const url = "/Portal/Medications";

    const params: Record<string, string | number> = {
      patientId,
    };

    if (page !== undefined) {
      params.page = page;
    }
    if (pageSize !== undefined) {
      params.pageSize = pageSize;
    }

    return api.get<IPaginatedResponse<any>>(url, { params });
  },

  async getMedicationAdherence(
    patientMedicationId: string,
    fromDate?: string,
    toDate?: string
  ): Promise<AxiosResponse<IMedicationAdherenceResponse>> {
    const url = `/Portal/Medications/${patientMedicationId}/Adherence`;

    const params: Record<string, string> = {};

    if (fromDate !== undefined) {
      params.from = fromDate;
    }
    if (toDate !== undefined) {
      params.to = toDate;
    }

    return api.get<IMedicationAdherenceResponse>(url, { params });
  },
};
